<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<figure class="figure">
<p class="fig"><img alt="" height="408" src="images/Chi-rapp-fig01001.jpeg" width="600"/></p>
<p class="figh"><a class="page" id="pxiv"></a>Mike “King” Kelly, baseball’s first matinee idol, inspired the cheer “Slide, Kelly, Slide,” which became the title of a Tin Pan Alley ditty and a painting hung in many barrooms. (Courtesy of the McGreevey Collection, Boston Public Library.)</p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-rapp-0010.vue?3f971358